import { PayloadAction, SliceCaseReducers, createSlice } from '@reduxjs/toolkit';
import { GerenciadorPrecos } from '../../@types/GerenciadorPrecos';
import { RootState } from '../../@types/RootState';

/** Linha da grade que recebeu o clique direito: a principal, a sub-linha Atacado ou a sub-linha Oferta. */
export type ContextMenuRow = 'REGULAR' | 'WHOLESALE' | 'OFFER';

export type ContextMenuState = {
  rowData: GerenciadorPrecos.RowData;
  row: ContextMenuRow;
} | null;

const initialState: ContextMenuState = null;

const slice = createSlice<ContextMenuState, SliceCaseReducers<ContextMenuState>>({
  name: 'ipa/gerenciador/contextMenu',
  initialState,
  reducers: {
    SET_GERENCIADOR_CONTEXT_MENU: (_state, { payload }: PayloadAction<ContextMenuState>) => {
      return payload;
    },
  },
});

const { SET_GERENCIADOR_CONTEXT_MENU } = slice.actions;

const selectorContextMenu = (state: RootState) => {
  return state.gerenciadorPrecosReducer.contextMenu?.rowData ?? null;
};

export const selectorContextMenuRow = (state: RootState) => {
  return state.gerenciadorPrecosReducer.contextMenu?.row;
};

export const selectorContextMenuItemOffer = (state: RootState) => {
  return state.gerenciadorPrecosReducer.contextMenu?.rowData.offer;
};

export { SET_GERENCIADOR_CONTEXT_MENU, initialState, selectorContextMenu };

export default slice.reducer;
